import { TIME_ZONE, formatDate, formatTime } from '@deizi/shared';
import { ApiClientError } from './api';

/** pt-BR message for an API error, for alerts and toasts. */
export function errorMessage(err: unknown): string {
  if (!(err instanceof ApiClientError)) return 'Algo deu errado. Tente de novo.';
  switch (err.code) {
    case 'network_error':
      return 'Sem conexão com o servidor. Confira a internet e tente de novo.';
    case 'last_admin':
      return 'Você é o único Admin. Promova outra pessoa a Admin primeiro.';
    case 'forbidden':
      return 'Só o Admin pode fazer isso.';
    case 'conflict':
      return /email/i.test(err.message)
        ? 'Já existe um usuário com esse e-mail.'
        : 'Essa ação não se aplica mais. Atualize a página.';
    case 'rate_limited':
      return 'Muitas tentativas. Espere alguns minutos.';
    case 'validation_error':
      return 'Confira os campos e tente de novo.';
    case 'unauthorized':
      return 'Sua sessão terminou. Entre de novo.';
    default:
      return 'Algo deu errado. Tente de novo.';
  }
}

function dayKey(d: Date): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: TIME_ZONE }).format(d);
}

/** "hoje 09h12", "ontem 18h40" or "06/10/2026". */
export function formatWhen(iso: string | null, now = new Date()): string {
  if (!iso) return '—';
  const d = new Date(iso);
  const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  if (dayKey(d) === dayKey(now)) return `hoje ${formatTime(d)}`;
  if (dayKey(d) === dayKey(yesterday)) return `ontem ${formatTime(d)}`;
  return formatDate(d);
}

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
